var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrap input--job"},[_c('input',{attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._v(" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.SearchIcon)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6d2366a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsInput.vue
// module id = null
// module chunks = 